var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Tag component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTag extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.21241 2.54685L9.21537 2.54987ZM9.28384 2.61854L21.2725 14.6072C21.3512 14.686 21.3955 14.7929 21.3955 14.9044C21.3955 15.0158 21.3512 15.1227 21.2725 15.2015L15.202 21.272C15.1232 21.3507 15.0163 21.395 14.9049 21.395C14.7934 21.395 14.6865 21.3507 14.6077 21.272L2.61903 9.28335L3.50868 3.50819L9.28384 2.61854ZM2.54733 9.21192C2.54836 9.2129 2.54936 9.21388 2.55036 9.21488ZM22.3335 16.2619L16.2624 22.333C15.9023 22.6926 15.4138 22.895 14.9049 22.895C14.3959 22.895 13.9078 22.693 13.5477 22.3333L1.50344 10.2891C1.36565 10.1553 1.25889 9.99283 1.19074 9.81318C1.12139 9.63033 1.09379 9.43429 1.10996 9.23941C1.11141 9.22196 1.11347 9.20457 1.11614 9.18726L2.0324 3.2393C2.05943 2.92867 2.19505 2.63689 2.41621 2.41572C2.63737 2.19456 2.92915 2.05894 3.23979 2.03191L9.18775 1.11565C9.20505 1.11298 9.22245 1.11092 9.2399 1.10948C9.43478 1.0933 9.63082 1.1209 9.81366 1.19025C9.99332 1.2584 10.1558 1.36516 10.2896 1.50295L22.3335 13.5469C22.6931 13.907 22.8955 14.3954 22.8955 14.9044C22.8955 15.4133 22.6931 15.9018 22.3335 16.2619Z"
          />
          <path
            d="M7.49129 8.27152C7.92226 8.27152 8.27164 7.92214 8.27164 7.49117C8.27164 7.06019 7.92226 6.71082 7.49129 6.71082C7.06031 6.71082 6.71094 7.06019 6.71094 7.49117C6.71094 7.92214 7.06031 8.27152 7.49129 8.27152Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.49129 7.46082C7.47453 7.46082 7.46094 7.4744 7.46094 7.49117C7.46094 7.50793 7.47453 7.52152 7.49129 7.52152C7.50805 7.52152 7.52164 7.50793 7.52164 7.49117C7.52164 7.4744 7.50805 7.46082 7.49129 7.46082ZM5.96094 7.49117C5.96094 6.64598 6.6461 5.96082 7.49129 5.96082C8.33648 5.96082 9.02164 6.64598 9.02164 7.49117C9.02164 8.33635 8.33648 9.02152 7.49129 9.02152C6.6461 9.02152 5.96094 8.33636 5.96094 7.49117Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTag.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTag.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTag.prototype, "size", void 0);
if (customElements.get('cat-icon-tag') === undefined) {
    customElements.define('cat-icon-tag', BlocksIconTag);
}
